class CopyButton extends HTMLElement {
  connectedCallback() {
   
    this.textContent = this.getAttribute('data-text-original') || 'Copy';
    this.style.cursor = 'pointer';

    this.addEventListener('click', () => this.handleCopy());
  }

  handleCopy() {
    const text = this.getAttribute('data-copy-data');
    const successText = this.getAttribute('data-text-success') || 'Copied';
    const originalText = this.getAttribute('data-text-original') || 'Copy';

    navigator.clipboard.writeText(text).then(() => {
      this.textContent = successText;
      setTimeout(() => {
        this.textContent = originalText;
      }, 2000);
    });
  }
}


customElements.define('copy-button', CopyButton);